import React from 'react';
import { connect } from 'react-redux';
import { Handler } from 'ml-component-web';
import HomeHandlerView from './HomeHandlerView';

class HomeHandler extends Handler {
    constructor(props, context) {
        super(props, context, HomeHandlerView);
    }

    render() {
        return (
            <HomeHandlerView />
        );
    }
}

function mapStateToProps(state, props) {
    return {
        referrerId: props.location && props.location.query && props.location.query.u,
    };
}

export default connect(mapStateToProps)(HomeHandler);



/** WEBPACK FOOTER **
 ** ./src/handler/HomeHandler.js
 **/